import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { HotlineText } from '../../../../../../components/HotlineBarFixed/components/Hotline/components/HotlineText.js';
import { PhoneNumberMobile } from '../../../../../../components/HotlineBarFixed/components/Hotline/components/Mobile/components/PhoneNumberMobile.js';
import { Stack } from '../../../../../../primitives/index.js';
export const HotlineMobile = ({
  phoneNumber,
  openingHours
}) => {
  const {
    t
  } = useTranslation();
  return _jsxs(Stack, {
    direction: "row",
    spacing: "small",
    alignItems: "center",
    children: [_jsx(PhoneNumberMobile, {
      children: phoneNumber
    }), _jsx(HotlineText, {
      color: "contentInversePrimary",
      children: t('header:hotline.text.short', {
        openingHours
      })
    })]
  });
};